module.exports = __webpack_public_path__ + "static/media/person9.50622d74.svg";